
import React from 'react';
import styles from './profilesettings.module.scss';
import { KoTitle } from 'packages';
import TimeIntervalForm from './slot';


export default function ProfileSettings({userData}) {



  return (
    <div className={styles.wrapper}>
      <KoTitle text='Availability (Weekly hours)' level={5} className={styles.title} />
      <div className={styles.card}>
        <div className={styles.content}>
          <TimeIntervalForm userData={userData}/>
        </div>
      </div>
    </div>
  );
}
